/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { antiscalantDosingStyle } from './antiscalant_style';
import { ArialB600, ChineseFonts, RationValWidth } from '../fonts/font';
import { Styles } from '../tableStyles';
import SubLine from '../createLine';

const borderColor = '#B3D3D7';
let tablewidth = 100;
let headercount = 1;
const rowWidthInc = 3;

const AntiscalantDosing = (props) => {
  const { argo_summary, tableWidth, serialNum, langualgeCheck, translateObject } = props;
  tablewidth = tableWidth;
  const herder_val = ['Dosed In', 'Antiscalant', { h: 'Dosage in Feed', h1: ['ppm', 'Kg/day'] }];
  headercount = herder_val.length;
  const splitHeaderData = (ele, parentInd) => {
    return Object.prototype.toString.call(ele) === '[object Array]' ? (
      ele.map((dta, ind) => (
        <View key={ind}
          style={[
            { width: RationValWidth((tablewidth / headercount) / ele.length - 2), borderTop: 1, borderLeft: 1, borderColor },
            parentInd === 0 && { width: RationValWidth((tablewidth / headercount) * rowWidthInc) / ele.length },
            ind === 0 && { borderLeft: 0 }
          ]}
        >
          <Text
            style={[
              antiscalantDosingStyle.tableCell, antiscalantDosingStyle.restChild, { padding: '5 0' },
              langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }
            ]}
          >
            {translateObject(dta)}
          </Text>
        </View>
      ))
    ) : (
      <Text
        style={[
          antiscalantDosingStyle.tableCell, antiscalantDosingStyle.restChild, { padding: '5 0' },
          langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }
        ]}
      >
        {translateObject(ele)}
      </Text>
    );
  };
  const createHeader = (item) => {
    return (
      <View style={[antiscalantDosingStyle.tableRow, { width: RationValWidth(tablewidth - 3) }]}>
        {item.map((ele, ind) => {
          return (
            <View key={ind}
              style={[
                antiscalantDosingStyle.tableCol, { borderRightColor: borderColor },
                (item.length - 1 === ind) && { borderRightWidth: 0 },
                { width: RationValWidth((tablewidth / headercount)) },
                // ind === 0 && { width: RationValWidth(tablewidth / headercount) * rowWidthInc }
              ]}
            >
              {Object.prototype.toString.call(ele) === '[object Object]' ? (
                Object.keys(ele).map((data, keyInd) => (
                  <View key={keyInd}
                    style={[
                      antiscalantDosingStyle.flexDirection,
                    ]}
                  >
                    {splitHeaderData(ele[data], ind)}
                  </View>
                ))
              ) : (
                <View>
                  <Text
                    style={[
                      antiscalantDosingStyle.tableCell, antiscalantDosingStyle.restChild, { padding: '4 5' },
                      langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }
                    ]}
                  >
                    {ele.toLowerCase() === 'waste' ? 'Conc.' : translateObject(ele)}
                    {ele.toLowerCase() === 'recovery' && ' (%)'}
                    {ele.toLowerCase() === 'electrode' && ' Bleed'}
                  </Text>
                  {/* <Text style={[antiscalantDosingStyle.restChild, { fontSize: RationValWidth(16), fontFamily: ArialB600 }]}>
                    {ele.toLowerCase() === 'recovery' ? '' : `(${defaultUnit['Volume Flow']})`}
                  </Text> */}
                </View>
              )}
            </View>
          );
        })}
      </View>
    );
  };

  const createContent = (items) => {
    return (
      <View style={{ width: '100%' }}>
        {Object.keys(items).map((typeData, typeindex) => {
          return (
            <View
              style={[
                antiscalantDosingStyle.tablebodyRow1, { width: RationValWidth(tablewidth), margin: '0' }
              ]}
              key={typeindex}
            >
              <View
                style={[
                  antiscalantDosingStyle.flexDirection,
                  { width: RationValWidth(tablewidth / headercount) * rowWidthInc },
                ]}>
                <View style={[antiscalantDosingStyle.tablebodyCol1]}>
                  <Text style={[antiscalantDosingStyle.tableCell, { padding: '4 0' }]}>{items?.[typeData]?.['Dosed In'] || ''}</Text>
                </View>
                <View style={[antiscalantDosingStyle.tablebodyCol1]}>
                  <Text style={[antiscalantDosingStyle.tableCell, { padding: '4 0' }]}>{items?.[typeData]?.Antiscalant || ''}</Text>
                </View>
                <View style={[antiscalantDosingStyle.flexDirection]}>
                  <View style={[antiscalantDosingStyle.tablebodyCol1, { width: RationValWidth((tablewidth / headercount) / 1.33) }]}>
                    <Text style={[antiscalantDosingStyle.tableCell, { padding: '4 0', marginRight: '30%' }]}>{items[typeData]['Dosage ppm in Feed'] === 'N.A' ? 'N.A' : (typeof items[typeData]['Dosage ppm in Feed'] === 'number' ? items[typeData]['Dosage ppm in Feed'].toFixed(2) : items[typeData]['Dosage ppm in Feed'] || '')}</Text>
                  </View>
                  <View style={[antiscalantDosingStyle.tablebodyCol1, { width: RationValWidth((tablewidth / headercount) / 1.33) }]}>
                    <Text style={[antiscalantDosingStyle.tableCell, { padding: '4 0', marginRight: '30%' }]}>{items[typeData]['Dosage kgperday in Feed'] === 'N.A' ? 'N.A' : (typeof items[typeData]['Dosage kgperday in Feed'] === 'number' ? items[typeData]['Dosage kgperday in Feed'].toFixed(2) : items[typeData]['Dosage kgperday in Feed'] || '')}</Text>
                  </View>
                </View>
              </View>
            </View>
          );
        })}
      </View>
    );
  };
  return (
    <View id="dynamic-height">
      {/* Header of the page */}
      <View style={Styles.mainHeader} >
        <Text style={[Styles.mainHeaderText, { paddingRight: 5 }, langualgeCheck && { fontFamily: ChineseFonts }]} >{serialNum}. {translateObject('Antiscalant Dosage Summary')}</Text>
        {/* I reduced the line width to accommodate the text and added a margin left. --->kranthi */}
        <SubLine lineWidth='60%' lineHeight='24' />
      </View>
      <View style={[antiscalantDosingStyle.mainTable, { width: RationValWidth(tablewidth) }]}>
        {createHeader(herder_val)}
        {createContent(argo_summary, herder_val)}
      </View>
    </View>
  );
};

export default AntiscalantDosing;
